import React from "react";

function HomeMatchResultBadge({ partido }) {
    const aguadaScore = Number(partido?.totalAguadaStats?.totalPuntos);
    const rivalScore = Number(partido?.totalAdversarioStats?.totalPuntos);

    if (!Number.isFinite(aguadaScore) || !Number.isFinite(rivalScore) || aguadaScore === rivalScore) {
        return null;
    }

    const aguadaGano = aguadaScore > rivalScore;

    return (
        <span className={`inline-flex items-center rounded-full border px-4 py-2 text-xs font-black uppercase tracking-widest ${
            aguadaGano
                ? "border-green-400/30 bg-green-500/10 text-green-400"
                : "border-red-400/30 bg-red-500/10 text-red-400"
        }`}>
            {aguadaGano ? "Victoria" : "Derrota"}
        </span>
    );
}

export default HomeMatchResultBadge;
